import JacksonReducer from './jackson_reducer';

export default JacksonReducer;
